import { useNavigate } from "react-router-dom";
import RiraLogo from "./RiraLogo";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Features",    path: "/" },
      { label: "Pricing",     path: "/pricing" },
      { label: "Sign In",     path: "/auth" },
      { label: "Get Started", path: "/auth?tab=register" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About",   path: "/about" },
      { label: "Contact", path: "/contact" },
      { label: "FAQ",     path: "/faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy",   path: "/privacy" },
      { label: "Terms of Service", path: "/terms" },
    ],
  },
];

function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-brand-col">
          <div className="lp-footer-brand">
            <RiraLogo size={28} showTagline />
          </div>
          <div className="lp-footer-copy">&copy; {year} Rira. All rights reserved.</div>
        </div>
        <div className="lp-footer-cols">
          {COLS.map((col) => (
            <div key={col.title} className="lp-footer-col">
              <div className="lp-footer-col-title">{col.title}</div>
              {col.links.map((link) => (
                <button key={link.label} className="lp-footer-link" onClick={() => navigate(link.path)}>
                  {link.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
